import axios from 'axios'
import { baseUrl } from '@/config/baseUrl'

const request = axios.create({
  // 切换环境请改 src/config/baseUrl.js
  baseURL: baseUrl,
  timeout: 15000
})

request.interceptors.response.use(
  (response) => {
    const res = response.data
    // 兼容统一包装 { code, msg, data }
    if (res && typeof res === 'object' && Object.prototype.hasOwnProperty.call(res, 'code')) {
      if (res.code === 0) {
        return res.data
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  (error) => Promise.reject(error)
)

export default request
